// document.addEventListener("DOMContentLoaded", function(){

//   function initFlatpickr(){

//     if (typeof flatpickr === "undefined") {
//       console.error("❌ Flatpickr NOT loaded");
//       return;
//     }

//     const dobInput = document.getElementById("dobInput");
//     const anniversaryInput = document.getElementById("anniversaryInput");

//     console.log("Init Flatpickr:", dobInput, anniversaryInput);

//     if (dobInput) {
//       if (dobInput._flatpickr) dobInput._flatpickr.destroy();

//       flatpickr(dobInput, {
//         dateFormat: "d/m/Y",
//         maxDate: "today",
//         allowInput: false, // 🔥 IMPORTANT
//         clickOpens: true
//       });
//     }

//     if (anniversaryInput) {
//       if (anniversaryInput._flatpickr) anniversaryInput._flatpickr.destroy();

//       flatpickr(anniversaryInput, {
//         dateFormat: "d/m/Y",
//         maxDate: "today",
//         allowInput: false,
//         clickOpens: true
//       });
//     }
//   }

//   // 🌍 make global
//   window.loadFlatpickr = initFlatpickr;

// });




document.addEventListener("DOMContentLoaded", function(){

  function initFlatpickr(){

    if (typeof flatpickr === "undefined") {
      console.error("❌ Flatpickr NOT loaded");
      return;
    }

    const dobInput = document.getElementById("dobInput");
    const anniversaryInput = document.getElementById("anniversaryInput");

    console.log("Init Flatpickr:", dobInput, anniversaryInput);

    /* DOB */
    if (dobInput) {
      if (dobInput._flatpickr) dobInput._flatpickr.destroy();

      flatpickr(dobInput, {
        dateFormat: "d/m/Y",
        maxDate: "today",
        allowInput: false,
        clickOpens: true,
        disableMobile: true   // 🔥 ADD THIS
      });

      /* ✅ FORCE placeholder (mobile fix) */
      dobInput.setAttribute("placeholder", "DD/MM/YYYY");
    }

    /* ANNIVERSARY */
    if (anniversaryInput) {
      if (anniversaryInput._flatpickr) anniversaryInput._flatpickr.destroy();

      flatpickr(anniversaryInput, {
        dateFormat: "d/m/Y",
        maxDate: "today",
        allowInput: false,
        clickOpens: true,
        disableMobile: true   // 🔥 ADD THIS
      });

      /* ✅ FORCE placeholder */
      anniversaryInput.setAttribute("placeholder", "DD/MM/YYYY");
    }
  }

  /* 🌍 make global */
  window.loadFlatpickr = initFlatpickr;

});